module.exports = __webpack_public_path__ + "static/4-011bf7a9fb94f3a422fbb528d95a0b47.png";